import React, { useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import classNames from "classnames";
import Cookies from 'universal-cookie';

export const AppTopbar = (props) => {
    let navigate = useNavigate();
    // const cookies = new Cookies();
    const cookies = useMemo(() => new Cookies(), []);

    const cerrarSesion = () => {
        cookies.remove('id', { path: '/' });
        cookies.remove('username', { path: '/' });
        cookies.remove('email', { path: '/' });
        cookies.remove('nombre', { path: '/' });
        cookies.remove('apellido', { path: '/' });
        cookies.remove('docIdentidad', { path: '/' });
        cookies.remove('fecNacimiento', { path: '/' });
        cookies.remove('nroTelefono', { path: '/' });
        cookies.remove('estado', { path: '/' });
        navigate('/index');
    }

    useEffect(() => {
        if (!cookies.get('id')) {
            navigate('/index');
        }
    }, [cookies, navigate]);

    return (
        <div className="layout-topbar">
            <Link to="/" className="layout-topbar-logo" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src="/logos/clioydike.png" alt="UA" style={{ width: "22%", height: "22%" }} />
            </Link>

            <button type="button" className="p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}>
                <i className="pi pi-bars" />
            </button>

            <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                <i className="pi pi-ellipsis-v" />
            </button>

            <ul className={classNames("layout-topbar-menu lg:flex origin-top", { "layout-topbar-menu-mobile-active": props.mobileTopbarMenuActive })}>
                <li>
                    <Link to="/perfil" className="p-link layout-topbar-button">
                        <i className="pi pi-user" />
                        <span>Perfil</span>
                    </Link>
                </li>
                <li>
                    <button className="p-link layout-topbar-button" onClick={cerrarSesion}>
                        <i className="pi pi-sign-out" />
                        <span>Cerrar Sesion</span>
                    </button>
                </li>
            </ul>
        </div>
    );
};
